import React, { useState, useEffect } from "react";
import {SinhalaData, EnglishData, TamilData} from  "./../../../../dummyData/handbookDummyData";
import { useSelector } from "react-redux";

import PDFViewerImage2 from "../../../../assets/PDFViewerImages/PDFViewerImage2.jpg";
import PDFViewerImage3 from "../../../../assets/PDFViewerImages/PDFViewerImage3.jpg";
import PDFViewerImage4 from "../../../../assets/PDFViewerImages/PDFViewerImage4.jpg";

const Chapter6 = () => {
    const selectedLanguage = useSelector((state) => state.language.language);
  const [language, setLanguage] = useState(SinhalaData[0]);

    useEffect(() => {
        switch (selectedLanguage.value) {
          case "english":
            setLanguage(EnglishData[0]);
            break;
          case "tamil":
            setLanguage(TamilData[0]);
            break;
          default:
            setLanguage(SinhalaData[0]);
            break;
        }
      }, [selectedLanguage]);
    
    return (
        <>

             {/* Chapter 6 */}
                            <section id="section6" className="drivers-handbook-section">
                                <h2 className="drivers-handbook-heading">
                                    {language.chapter6Title}
                                </h2>
            
                                <p className="drivers-handbook-paragraph">
                                    {language.chapter6Paragraph1}
                                </p>
            
                                <p className="drivers-handbook-paragraph">
                                    {language.chapter6Paragraph2}
                                </p>
            
                                <p className="drivers-handbook-paragraph">
                                    {language.chapter6Paragraph3}
                                </p>
            
                                <h3 className="drivers-handbook-subheading">
                                     {language.chapter6Subheading1}
                                </h3>
                                <ul className="drivers-handbook-list">
                                    <li>{language.chapter6List11}</li>
                                    <li>{language.chapter6List12}</li>
                                    <li>
                                        {language.chapter6List13}
                                    </li>
                                    <li>{language.chapter6List14}</li>
                                    <li>
                                        {language.chapter6List15}
                                    </li>
                                    <li>{language.chapter6List16}</li>
                                    <li>{language.chapter6List17}</li>
                                </ul>
            
                                <p className="drivers-handbook-paragraph">
                                    {language.chapter6Paragraph4}
                                </p>
            
                                <h3 className="drivers-handbook-subheading">{language.chapter6Subheading2}</h3>
                                <p className="drivers-handbook-paragraph">
                                    {language.chapter6Paragraph5}
                                </p>
            
                                <ul className="drivers-handbook-list">
                                    <li>
                                       {language.chapter6List2}
                                    </li>
                                </ul>
            
                                <h3 className="drivers-handbook-subheading">
                                    {language.chapter6Subheading3}
                                </h3>
                                <ul className="drivers-handbook-list">
                                    <li>{language.chapter6List31}</li>
                                    <li>{language.chapter6List32}</li>
                                    <li>
                                        {language.chapter6List33}
                                    </li>
                                    <li>{language.chapter6List34}</li>
                                    <li>{language.chapter6List35}</li>
                                    <li>{language.chapter6List36}</li>
                                    <li>{language.chapter6List37}</li>
                                    <li>{language.chapter6List38}</li>
                                </ul>
            
                                <p className="drivers-handbook-paragraph">
                                   {language.chapter6Paragraph6}
                                </p>
            
                                <p className="drivers-handbook-paragraph">
                                     {language.chapter6Paragraph7}
                                </p>
            
                                <h3 className="drivers-handbook-subheading">
                                    {language.chapter6Subheading4}
                                </h3>
                                <ul className="drivers-handbook-list">
                                    <li>
                                       {language.chapter6List44}
                                    </li>
                                    <li>
                                        {language.chapter6List45}
                                    </li>
                                    <li>{language.chapter6List46}</li>
                                    <li>
                                        {language.chapter6List47}
                                    </li>
                                    <li>
                                        {language.chapter6List48}
                                    </li>
                                    <li>
                                        {language.chapter6List49}
                                    </li>
                                    <li>
                                        {language.chapter6List50}
                                    </li>
                                </ul>
            
                                <h3 className="drivers-handbook-subheading">
                                    {language.chapter6Subheading5}
                                </h3>
                                <p className="drivers-handbook-paragraph">
                                     {language.chapter6Paragraph8}
                                </p>
            
                                <h3 className="drivers-handbook-subheading">{language.chapter6Subheading6}</h3>
                                <ul className="drivers-handbook-list">
                                    <li>{language.chapter6List51}</li>
                                    <li>{language.chapter6List52}</li>
                                    <li>{language.chapter6List53}</li>
                                </ul>
            
                                <h3 className="drivers-handbook-subheading">{language.chapter6Subheading7}</h3>
                                <ul className="drivers-handbook-list">
                                    <li>{language.chapter6List61}</li>
                                    <li>
                                        {language.chapter6List62}
                                    </li>
                                    <li>{language.chapter6List63}</li>
                                </ul>
            
                                <h3 className="drivers-handbook-subheading">
                                    {language.chapter6Subheading8}
                                </h3>
                                <ul className="drivers-handbook-list">
                                    <li>{language.chapter6List71}</li>
                                    <li>
                                        {language.chapter6List72}
                                    </li>
                                </ul>
            
                                <h3 className="drivers-handbook-subheading">
                                    {language.chapter6Subheading9}
                                </h3>
                                <p className="drivers-handbook-paragraph">
                                    {language.chapter6Paragraph9}
                                </p>
            
                                <h3 className="drivers-handbook-subheading">
                                    {language.chapter6Subheading10}
                                </h3>
                                <p className="drivers-handbook-paragraph">
                                     {language.chapter6Paragraph10}
                                </p>
            
                                <h3 className="drivers-handbook-subheading">
                                    {language.chapter6Subheading11}
                                </h3>
                                <p className="drivers-handbook-paragraph">
                                    {language.chapter6Paragraph11}
                                </p>
                                <h3 className="drivers-handbook-subheading">
                                     {language.chapter6Subheading12}
            
                                </h3>
            
                                <div className="image-box">
                                    <img src={PDFViewerImage2} alt="Traffic Rules2"/>
                                </div>
                                <div className="image-box">
                                    <img src={PDFViewerImage3} alt="Traffic Rules3"/>
                                </div>
                                <div className="image-box">
                                    <img src={PDFViewerImage4} alt="Traffic Rules4"/>
                                </div>
            
            
                            </section>
        </>
    )

}

export default Chapter6;
